import { useState, useMemo } from "react";

const pdfViewer = {
  width: "95%",
  margin: "auto",
  marginTop: "1rem",
  paddingTop: "1rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

function Activity(props) {
  const [loaded] = useState(true);

  const url = useMemo(() => {
    return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
  }, [props]);

  return (
    <div style={pdfViewer}>
      <iframe
        id="pdf_iframe"
        src={url}
        width="90%"
        height="800px"
        style={{ display: loaded ? "block" : "none", zIndex: 10 }}
      ></iframe>
      {/* <DocViewer documents={docs} /> */}
      <h4
        className="text-center"
        style={{ display: !loaded ? "block" : "none", marginTop: "1rem" }}
      >
        <div className="spinner">
          Loading
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
      </h4>
    </div>
  );
}

export default Activity;
